
const CustomTooltip = ({ active, payload, label, xFormat, yFormat, toolTip }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          padding: '10px',
          borderRadius: '5px',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
        }}
      >
        {/* Format the X value (label) */}
        <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}>
          {xFormat ? xFormat(label) : label}
        </p>
        {payload.map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: '5px',
            }}
          >
            <div
              style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: item.color,
                //marginRight: '10px',
              }}
            ></div>
            {/* Series Name */}
            <p style={{ margin: 5, fontSize: '13px', color: '#333' }}>
              {/* {item.name} */}
              {(toolTip === "Time of Day" || toolTip === "Time of Week"?  (item.dataKey == 'y'? 'Sessions':'Transactions'): toolTip)}
            </p>
            {/* Format the Y value */}
            <p
              style={{
                margin: 0,
                marginLeft: 'auto',
                fontSize: '13px',
                fontWeight: 'bold',
                color: '#000',
              }}
            >
              {/* {yFormat && yFormat.length == 1 ? yFormat(item.payload.value, item.payload.sum) : item.value} */}
              {/* {yFormat && yFormat.length == 2 ? `${item.payload.formattedyValue}  (${yFormat(item.payload.value, item.payload.sum)}%)` : item.value} */}
              {yFormat && yFormat.length == 2 ? `${item.payload.value}  (${yFormat(item.payload.value, item.payload.sum)}%)` : item.value}
            </p>
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export default CustomTooltip;
